export default __webpack_public_path__ + "static/media/curveDaoIcon.897a3e29.png";